import {
  ApiTokenAuditSnapshotV1,
  ApiTokenInvocationAuditSnapshotV1,
  IAuditEventData,
} from 'api'
import { Box } from 'cs-kevlar-react'
import React from 'react'
import { serverDateToLocaleDateTimeString } from 'utils/dates'
import { DetailArrayField } from './DetailArrayField'
import { DetailField } from './DetailField'
import { UnavailableDetails } from './UnavailableDetails'
import { useDetailStyles } from './useDetailStyles'
import { resolveEventData, resolveSnapshots } from './utils'

interface ApiTokenDetailsProps {
  eventData: IAuditEventData
}

export const ApiTokenDetails: React.FunctionComponent<ApiTokenDetailsProps> = ({
  eventData,
}) => {
  const [originalSnapshot, updatedSnapshot] = resolveSnapshots<
    ApiTokenAuditSnapshotV1
  >(eventData, nameof<ApiTokenAuditSnapshotV1>())

  const invocationInfo = resolveEventData<ApiTokenInvocationAuditSnapshotV1>(
    eventData,
    nameof<ApiTokenInvocationAuditSnapshotV1>(),
  )

  if (!updatedSnapshot && !originalSnapshot && !invocationInfo)
    return <UnavailableDetails />

  const classes = useDetailStyles()
  const showDiff = !!originalSnapshot && !!updatedSnapshot

  return (
    <React.Fragment>
      {!!invocationInfo && (
        <Box className={classes.fieldsContainer}>
          <DetailField label="Username" original={invocationInfo.username} />

          <DetailField label="Token ID" original={invocationInfo.tokenId} />

          <DetailField label="URL" original={invocationInfo.url} />

          <DetailField
            label="HTTP Method"
            original={invocationInfo.httpMethod}
          />

          <DetailField
            label="Source IP Address"
            original={invocationInfo.ipAddress}
          />
        </Box>
      )}

      {!invocationInfo && (
        <Box className={classes.fieldsContainer}>
          <DetailField
            label="Username"
            original={originalSnapshot?.username}
            updated={updatedSnapshot?.username}
          />

          <DetailField
            label="Token ID"
            showDiff={showDiff}
            original={originalSnapshot?.id}
            updated={updatedSnapshot?.id}
          />

          <DetailField
            label="Expires On"
            showDiff={showDiff}
            original={serverDateToLocaleDateTimeString(
              originalSnapshot?.expiresOn,
            )}
            updated={serverDateToLocaleDateTimeString(
              updatedSnapshot?.expiresOn,
            )}
          />

          <DetailArrayField
            label="Scopes"
            showDiff={showDiff}
            original={originalSnapshot?.scopes}
            updated={updatedSnapshot?.scopes}
          />
        </Box>
      )}
    </React.Fragment>
  )
}
